import { watch } from 'vue';
import type { Store } from './store';

/**
 * Сгенерировать имя для сохранения данных в localStorage
 * @param stateName - имя свойства состояния
 * @param stateKey - ключ состояния, разные компоненты могут использовать одинаковый ключ
 */
const genStorageKey = <T extends Store>(stateName: keyof T, stateKey: string): string => {
	const stateNameString = String(stateName);

	return `top:${stateNameString}:${stateKey}`;
};

/**
 * Загрузить состояние
 * @param stateName - имя свойства состояния
 * @param store
 */
const loadLocalStorge = <T extends Store>(stateName: keyof T, store: T) => {
	// если Store.key не знадан, значит сохранение состояния в компоненте отключено
	if (!store.$id) return;

	const localStorageKey = genStorageKey(stateName, store.$id);

	try {
		const localStorageValue: typeof store[keyof typeof store] = JSON.parse(localStorage.getItem(localStorageKey) as string);

		if (typeof localStorageValue === typeof store[stateName]) {
			store[stateName] = localStorageValue;
		}
	} catch (e) {
		console.warn(new Error(`В localStorage[${localStorageKey}] не корректный json`));
	}
};

/**
 * Добавить автосохранение состояние при его изменении
 * @param stateName - имя свойства состояния
 * @param store
 */
const addSaverLocalStorge = <T extends Store>(stateName: keyof T, store: T) => {
	// если store.$id не знадан, значит сохранение состояния в компоненте отключено
	if (!store.$id) return;

	const localStorageKey = genStorageKey(stateName, store.$id);

	watch(() => store[stateName], () => {
		localStorage.setItem(localStorageKey, JSON.stringify(store[stateName]));
	}, { immediate: true });
};

export default {
	loadLocalStorge,
	addSaverLocalStorge,
};